import { ScoreRange } from '@viome/viome-base/src/usecase/Health/Health.model';

export const sortHealthReferenceByRankScore = (scoreRanges: ScoreRange[]) => {
  return scoreRanges.sort((a, b) => {
    return a.low_range - b.low_range;
  });
}; 